export const SIGNATURE_MAX_WIDTH = 486;
